export default "__VITE_ASSET__0c20af3c__"